<template>
  <div class="container">
    <div class="card maadi-dark-card" v-if="activity !== null">
      <div class="card-body">
        <div class="d-flex">
          <div style="font-weight: 500">
            {{ activity.subject }}
            <div style="font-weight: 300; font-size: 10px">
              GROUP ID: {{ activity.id }}
            </div>
          </div>
          <div class="ml-auto" style="font-weight: 300">
            <div>{{ activity.start_date | formatDate }}</div>
            <div class="text-right">{{ activity.user_name }}</div>
          </div>
        </div>
        <hr />
        <div style="font-weight: 300">
          {{ activity.note }}
        </div>
        <div class="p-2 m-2" style=""></div>
        <hr />
        <!-- ACCOUNTS INVOLVED -->
        <div class="p-2 mb-4" style="border: solid 1px #507499">
          <div class="d-flex align-items-center">
            <div>
              Accounts Involved
            </div>
            <div class="ml-auto" v-if="$store.getters.hasAdministrator">
              <button
                class="btn btn-sm maadi-button"
                @click="showAccountAdder = !showAccountAdder"
              >
                ADD ACCOUNT
              </button>
            </div>
          </div>
          <div
            class="mt-2"
            v-if="$store.getters.hasAdministrator && showAccountAdder"
            style="color: #000;"
          >
            <account-selector
              v-if="accountToAdd === null"
              v-on:selectedAccount="
                e => {
                  this.accountToAdd = e;
                }
              "
            ></account-selector>
            <div class="maadi-inlay p-3 d-flex" v-if="accountToAdd !== null">
              <div style="font-size: 1.3em; color: #FFFFFF;">
                {{ accountToAdd.name }}
              </div>
              <div class="ml-auto">
                <button
                  class="btn btn-sm maadi-button"
                  @click="addAccountToActivity"
                >
                  ADD
                </button>
                <button
                  class="btn btn-sm maadi-button"
                  @click="
                    e => {
                      this.showAccountAdder = false;
                      this.accountToAdd = null;
                    }
                  "
                >
                  REMOVE
                </button>
              </div>
            </div>
          </div>
          <div v-for="account in accountsInActivity" :key="account.activity_id">
            <single-account-in-activity
              v-bind:account="account"
              v-bind:activity="activity"
            ></single-account-in-activity>
          </div>
        </div>
        <!-- TYPE SELECTOR -->
        <div class="p-2 mb-4" style="border: solid 1px #507499">
          <div class="m-1">
            <div>Activity Categorization</div>
            <div style="font-weight: 300">
              Categorize, or recategorize, an activity. Click "SAVE" to persist
              any changes.
            </div>
          </div>
          <div class="d-flex flex-fill align-items-end">
            <div class="m-1">
              Activity Type
              <b-form-select
                size="sm"
                v-model="activity.activity_type"
                :options="activityTypeMapping"
              ></b-form-select>
            </div>
            <div class="m-1" v-if="false">
              Activity Subtype
              <b-form-select
                size="sm"
                v-model="activity.activity_sub_type"
                :options="activitySubTypeMapping"
              ></b-form-select>
            </div>
            <div class="m-1">
              Initiative Type
              <b-form-select
                size="sm"
                v-model="activity.initiative_type"
                :options="initiativeTypes"
              ></b-form-select>
            </div>
            <div
              class="d-flex justify-content-end align-items-center ml-auto m-1"
            >
              <button class="btn btn-sm maadi-button" @click="updateCategory">
                SAVE
              </button>
            </div>
          </div>
        </div>
        <!-- AUTHOR SELECTOR -->
        <div class="p-2 mb-4" style="border: solid 1px #507499">
          <div class="m-1">
            <div>Change Author</div>
            <div style="font-weight: 300">
              Change the Medical Alley Association staff member involved in this
              activity. This will typically be done when staff have entered on
              behalf of a different staff member.
            </div>
          </div>
          <div class="d-flex flex-fill">
            <div class="m-1" v-if="onBehalfOfOptions !== null">
              <b-form-select
                size="sm"
                v-model="activity.author_id"
                :options="onBehalfOfOptions"
              ></b-form-select>
            </div>
            <div class="d-flex justify-content-end ml-auto m-1">
              <button class="btn btn-sm maadi-button" @click="changeAuthor">
                SAVE
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "../../api/activity";
import SingleAccountInActivity from "./SingleAccountInActivity";
import AccountSelector from "../tools/AccountSelector";
import ActivityConstants from "./ActivityConstants";

export default {
  name: "",
  components: { SingleAccountInActivity, AccountSelector },
  computed: {
    accountsInActivity() {
      return this.activity.account_objects;
    },
    showSubtypes() {
      return ActivityConstants.showSubTypes;
    },
    activityTypeMapping() {
      let activityTypes = [];
      ActivityConstants.activityMapping.forEach(x => {
        activityTypes.push(x.type);
      });
      return activityTypes;
    },
    activitySubTypeMapping() {
      let activityTypeObject = ActivityConstants.activityMapping.filter(
        x => x.type === this.activity.activity_type
      );
      return activityTypeObject[0].subTypes;
    }
  },
  data: function() {
    return {
      activityID: null,
      activity: null,
      isLoading: false,
      activityType: [
        { text: "", value: null },
        { text: "Meeting", value: "Meeting" },
        { text: "Referrals", value: "Referrals" },
        { text: "Renewals", value: "Renewals" },
        { text: "Advocacy ", value: "Advocacy" },
        { text: "Invitation", value: "Invite" },
        { text: "Testimonial", value: "Testimonial" },
        { text: "Content", value: "Content" },
        { text: "Sponsorship", value: "Sponsorship" },
        { text: "COVID-19", value: "COVID-19" }
      ],
      initiativeTypes: [
        { text: "", value: null },
        { text: "Health Equity", value: "Health Equity" },
        { text: "HR & Talent", value: "HR & Talent" },
        { text: "International Efforts", value: "International Efforts" },
        { text: "Medical Alley Starts", value: "Medical Alley Starts" },
        { text: "Supply Chain", value: "Supply Chain" }
      ],
      onBehalfOfOptions: null,
      //  account adder
      accountToAdd: null,
      showAccountAdder: false
    };
  },
  methods: {
    setActivity() {
      this.$store.commit("setIsLoading", true);
      this.activity = null;
      API.getActivity(this.activityID).then(response => {
        console.log(response);
        this.activity = response.data.data;
        this.$store.commit("setIsLoading", false);
      });
    },
    changeAuthor() {
      this.$store.commit("setIsLoading", true);
      API.updateActivityAuthor(this.activity.id, this.activity.author_id).then(
        response => {
          this.$store.commit("setIsLoading", false);
        }
      );
    },
    setAuthors() {
      API.getOnBehalfOfUsers().then(response => {
        this.onBehalfOfOptions = response.data.data;
      });
    },
    addAccountToActivity() {
      this.$store.commit("setIsLoading", true);
      API.addAccountToActivity(
        this.activity.id,
        this.accountToAdd.account_id
      ).then(response => {
        if (response.data.success) {
          this.accountToAdd = null;
          this.showAccountAdder = false;
          this.setActivity();
        } else {
          console.log(response);
          this.$store.commit("setIsLoading", false);
        }
      });
    },
    updateCategory() {
      this.$store.commit("setIsLoading", true);
      API.updateActivityCategory(this.activity.id, this.activity).then(
        result => {
          this.$store.commit("setIsLoading", false);
        }
      );
    }
  },
  mounted() {
    this.activityID = this.$route.params.id;
    this.setActivity();
    this.setAuthors();
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/activities/SingleActivity.vue